// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23Kru","importantInfo":"styles_importantInfo__yNkyl"};